"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const ICardRenderDescription_1 = require("@/common/cards/render/ICardRenderDescription");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardDescription',
    props: {
        item: {
            required: true,
        },
    },
    computed: {
        classes() {
            const classes = ['card-description'];
            if ((0, ICardRenderDescription_1.isIDescription)(this.item)) {
                if (this.item.align !== 'center') {
                    classes.push('card-description-aligned');
                }
                classes.push('card-description-align--' + this.item.align);
            }
            return classes;
        },
        description() {
            return (0, ICardRenderDescription_1.isIDescription)(this.item) ? this.item.text : String(this.item);
        },
    },
});
